<dx-button-group class="button-group" width="100%"
  keyExpr="id"
  [items]="items"
  [selectedItemKeys]="[selectedItemKeys]"
  [stylingMode]="stylingMode"
  (onItemClick)="itemClicked.emit($event.itemData.id)">
</dx-button-group>
